var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBrandinginline = function SvgBrandinginline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EB4748",
    d: "M0 12.145 5.98 22.5h12.002L24 12.145 17.982 1.5H5.98z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M9.501 15.112c-.19-.684-.666-2.14-1.508-3.277-.267-.361-.336-.851-.114-1.24 1.834-3.213 2.517-4.4 2.771-4.839a.57.57 0 0 1 .45-.256h.494-.097v4.605a1.25 1.25 0 1 0 1-.002V5.502h.403c.166.001.368.115.451.259.255.438.938 1.625 2.771 4.834.223.39.154.88-.113 1.24-.842 1.138-1.317 2.594-1.508 3.278a.525.525 0 0 1-.502.387h-3.996a.526.526 0 0 1-.502-.388",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M9 17.831c0-.736.597-1.333 1.333-1.333h3.334c.736 0 1.333.597 1.333 1.333a.667.667 0 0 1-.667.667H9.667A.667.667 0 0 1 9 17.831"
  })));
};
export default SvgBrandinginline;